import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import { Settings } from 'luxon';
// @ts-ignore
import wysiwyg from 'vue-wysiwyg';
import '@/styles/index.scss';
import DetailFooter from '@/components/UI/DetailFooter.vue';
import BaseList from '@/components/BaseList.vue';
import Filters from '@/components/UI/Filters.vue';
import FilterItem from '@/components/UI/FilterItem.vue';
import DeleteModal from '@/components/DeleteModal.vue';
import EntitySelect from '@/components/EntitySelect.vue';
import EntityPicker from '@/components/EntityPicker.vue';
import Error from './components/UI/Error.vue';
import Dropdown from './components/UI/Dropdown.vue';
Vue.config.productionTip = false;

Vue.component('DeleteModal', DeleteModal);
Vue.component('entity-select', EntitySelect);
Vue.component('entity-picker', EntityPicker);
Vue.component('DetailFooter', DetailFooter);
Vue.component('Filters', Filters);
Vue.component('FilterItem', FilterItem);
Vue.component('error', Error);
Vue.component('dropdown', Dropdown);
Vue.component('BaseList', BaseList);
Vue.use(wysiwyg, {});

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');

Settings.defaultLocale = 'ru';
